import classname from 'classnames'
import p from 'prop-types'
import React from 'react'

import { ImageGatsby } from '../../../components'
import Image from '../../../datas/models/Image'
import { chainDecorators, memoized } from '../../../utils/ReactUtils'

import styles from './styles'


const decorators = [
  memoized,
]

function ProjectPhotos(props) {
  const { pictures } = props
  const p0 = pictures[0]
  const p1 = pictures.length > 1 ? pictures[1] : null
  const p2 = pictures.length > 2 ? pictures[2] : null

  return (
    <div className={classname('container', { cover: pictures.length === 1 })}>
      <aside>
        <div className="cover-image">
          <ImageGatsby src={p0} />
        </div>
      </aside>
      {pictures.length > 1 && (
        <div className="thumbs">
          {p1 && (
            <div className="thumb">
              <ImageGatsby src={p1} />
            </div>
          )}
          {p2 && (
            <div className="thumb">
              <ImageGatsby src={p2} />
            </div>
          )}
        </div>
      )}
      <style jsx>{styles}</style>
    </div>
  )
}

ProjectPhotos.propTypes = {
  pictures: p.arrayOf(Image.propTypes).isRequired,
}

ProjectPhotos = chainDecorators(decorators, ProjectPhotos)

export default ProjectPhotos
